import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeCreateMedicationMutation as useDeCreateMedicationMutationType } from "@/modules/patients/detail/medication/de/services/__generated__/useDeCreateMedicationMutation.graphql"
const mutation = graphql`
  mutation useDeCreateMedicationMutation($input: De_addMedicationInput!, $connections: [ID!]!) {
    de_addMedication(input: $input) {
      de_Medication @appendNode(connections: $connections, edgeTypeName: "De_medicationsEdge") {
        id
        ...deMedicationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useDeCreateMedicationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeCreateMedicationMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeCreateMedicationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeCreateMedicationMutation }
